module.exports = __webpack_public_path__ + "img/1577413426.ea1ac996.jpg";